export interface ImeKeyboardLikeEvent {
  keyCode?: number;
  nativeEvent?: {
    isComposing?: boolean;
    keyCode?: number;
  };
}

/**
 * Enter (and arrow keys) belong to the IME while a CJK/Indic/SEA composition
 * is active. keyCode 229 is retained for browsers that omit isComposing.
 */
export const isImeComposing = (event: ImeKeyboardLikeEvent): boolean =>
  event.nativeEvent?.isComposing === true
  || event.nativeEvent?.keyCode === 229
  || event.keyCode === 229;
